export default {
  baseUrl: {
    dev:window.location.origin,
    web_socket:window.location.origin
    // dev: "https://thunder-ci.lcola.cn/", // 开发环境
    // web_socket:"wss://thunder-ci-ws.lcola.cn",
  },
};